<section class="pull-activity" aria-label="Pull history">
  <app-data-list #jobsList class="data-list--plain" [fetch]="fetchJobs" [searchable]="false" [pageSize]="25" [trackByFn]="trackJob"
    emptyText="No pulls yet. Select cells on the map to start discovering leads.">
    <div list-filters class="pull-toolbar">
      <span class="br-small br-text-muted">History</span>
      <button type="button" class="br-btn br-btn--ghost br-icon-btn" (click)="refreshVisible()" aria-label="Refresh history" title="Refresh">
        <br-icon>refresh</br-icon>
      </button>
    </div>
    <ng-template dataListItem let-job>
      <app-pull-job-item [job]="job" [initiallyExpanded]="newJobId === job.jobId"></app-pull-job-item>
    </ng-template>
  </app-data-list>
</section>
